import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

function PercorsoImage({ image, delay }) {
    return (
        <div className="relative w-full h-full overflow-hidden rounded-md">
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
            <img src={image.src} alt={image.alt} className="w-full h-full object-cover" />
            {image.title && (
                <>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
                    <div className="absolute bottom-5 left-0 w-full p-6">
                        <h3 className="font-bold text-xl lg:text-3xl panoragraf-light uppercase text-mcare-green mb-2 text-balance" data-aos="fade-up" data-aos-duration="1200">{image.title}</h3>
                        <p className="text-white text-sm lg:text-xl text-balance" data-aos="fade-up" data-aos-delay={delay}>{image.description}</p>
                    </div>
                </>
            )}
        </div>
    );
}

export default function Percorso({
    title,
    subtitle,
    tags,
    images,
    delay,
}) {
    return (
        <section className="min-h-screen text-white flex flex-col overflow-hidden py-10">
            <div className="text-center shrink-0 px-6">
                <h2 className="text-4xl md:text-5xl font-semibold text-mcare-green mb-8" data-aos="fade-up" data-aos-duration="1000">{title}</h2>
                <p className=" text-lg  w-full md:w-1/2 mx-auto" data-aos="fade" data-aos-delay="400">{subtitle}</p>
            </div>
            <div className="flex justify-center text-2xl font-bold mt-10 shrink-0 px-6">
                <p className="flex flex-col md:flex-row flex-wrap items-center justify-center gap-2 md:gap-3 text-center">
                    {tags.map((tag, index) => (
                        <span key={index} className="flex items-center gap-3" data-aos="fade-right" data-aos-delay={index * 300 + 400}>
                            {index > 0 && <span className="hidden md:inline">-</span>}
                            {tag}
                        </span>
                    ))}
                </p>
            </div>

            <div className="mt-10 px-4 md:px-20 flex-1 min-h-0">
                <Swiper
                    slidesPerView={1}
                    spaceBetween={20}
                    autoplay={{
                        delay: 3500,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    pagination={{
                        dynamicBullets: true,
                        clickable: true,
                    }}
                    breakpoints={{
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        },
                    }}
                    modules={[Autoplay, Pagination]}
                    className="w-full h-96 md:h-180 lg:h-full"
                >
                    {images.map((image, index) => (
                        <SwiperSlide key={index} className="h-full">
                            <PercorsoImage image={image} delay={index * 300}/>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}